import config from '../config';
import { authHeader } from '../helpers';
import axios from 'axios'
export const activityService = {
  create,
  get
};

async function create(params) {
  axios.post(`${config.API_URL}/user-activities`, params, { headers: authHeader() })
}

async function createLivechatLog(params) {
  axios.post(`${config.API_URL}/livechatlogs`, params, { headers: authHeader() })
}

async function get(params) {
  return await axios.get(`${config.API_URL}/user-activities`, {params: params, headers: authHeader()})
}
